import { logDispatcher } from 'src/app/core/decorators/state.decorators';
import {
  ServiceStudentAttendanceMonitorResponse,
  StudentsAttendancesValidateMonitorRequest,
} from '../models/student-attendance-monitor.model';
import { SchoolAttendanceMonitorResponse } from '../models/school-attendance-monitor.model';
import { StudentAttendancePredictionResponse } from '../models/student-attendance-prediction.model';
import { ServiceAttendanceAdjustmentResponse } from '../models/service-attendance-adjustment-response.model';

export namespace MonitorActions {
  @logDispatcher
  export class SetFilterCurrentExercise {
    static readonly type = '[Monitor] SetFilterCurrentExercise';
    constructor(
      public exerciseId: number,
      public startDate: Date,
      public endDate: Date
    ) {}
  }

  @logDispatcher
  export class SetFilterDate {
    static readonly type = '[Monitor] SetFilterDate';
    constructor(public date: Date) {}
  }

  @logDispatcher
  export class GetAttendances {
    static readonly type = '[Monitor] GetAttendances';
    constructor(public isContractForStudents: boolean) {}
  }

  @logDispatcher
  export class GetSchoolAttendanceMonitorSuccess {
    static readonly type = '[Monitor] GetSchoolAttendanceMonitorSuccess';
    constructor(public response: SchoolAttendanceMonitorResponse) {}
  }

  @logDispatcher
  export class GetStudentAttendanceMonitorSuccess {
    static readonly type = '[Monitor] GetStudentAttendanceMonitorSuccess';
    constructor(
      public response: ServiceStudentAttendanceMonitorResponse,
      public serviceId: number
    ) {}
  }

  @logDispatcher
  export class GetStudentAttendanceMonitorItems {
    static readonly type =
      '[Monitor] GetAttenGetStudentAttendanceMonitorItemsdances';
    constructor(public serviceId: number) {}
  }

  @logDispatcher
  export class GetStudentAttendancePrediction {
    static readonly type = '[Monitor] GetStudentAttendancePrediction';
    constructor() {}
  }

  @logDispatcher
  export class GetStudentAttendancePredictionSuccess {
    static readonly type = '[Monitor] GetStudentAttendancePredictionSuccess';
    constructor(public response: StudentAttendancePredictionResponse) {}
  }

  @logDispatcher
  export class GetServiceAttendanceAdjustment {
    static readonly type = '[Monitor] GetServiceAttendanceAdjustment';
    constructor() {}
  }

  @logDispatcher
  export class GetServiceAttendanceAdjustmentSuccess {
    static readonly type = '[Monitor] GetServiceAttendanceAdjustmentSuccess';
    constructor(public response: ServiceAttendanceAdjustmentResponse) {}
  }

  @logDispatcher
  export class EditAttendanceStatus {
    static readonly type = '[Monitor] EditAttendanceStatus';
    constructor(public index: number, public attendanceService: number) {}
  }

  @logDispatcher
  export class EditSchoolAttendanceAverage {
    static readonly type = '[Monitor] EditSchoolAttendanceAverage';
    constructor(public index: number, public average: number) {}
  }

  @logDispatcher
  export class EditServiceAttendanceAdjustment {
    static readonly type = '[Monitor] EditServiceAttendanceAdjustment';
    constructor(public index: number, public adjustment: number) {}
  }

  @logDispatcher
  export class SaveStudentAttendanceStatus {
    static readonly type = '[Monitor] SaveStudentAttendanceStatus';
    constructor(public index: number, public user: string) {}
  }

  @logDispatcher
  export class SaveStudentAttendanceStatusSuccess {
    static readonly type = '[Monitor] SaveAttendanceStatusSuccess';
    constructor() {}
  }

  @logDispatcher
  export class ValidateStudentAttendance {
    static readonly type = '[Monitor] ValidateStudentAttendance';
    constructor(public user: string) {}
  }

  @logDispatcher
  export class ValidateStudentAttendanceSuccess {
    static readonly type = '[Monitor] ValidateStudentAttendanceSuccess';
    constructor() {}
  }

  @logDispatcher
  export class SaveSchoolAttendance {
    static readonly type = '[Monitor] SaveSchoolAttendance';
    constructor(public user: string) {}
  }

  @logDispatcher
  export class SaveSchoolAttendanceSuccess {
    static readonly type = '[Monitor] SaveSchoolAttendanceSuccess';
    constructor() {}
  }

  @logDispatcher
  export class SaveStudentAttendancePrediction {
    static readonly type = '[Monitor] SaveStudentAttendancePrediction';
    constructor(
      public studentAttendancePredictionForm: StudentAttendancePredictionResponse,
      public user: string
    ) {}
  }

  @logDispatcher
  export class SaveStudentAttendancePredictionSuccess {
    static readonly type = '[Monitor] SaveStudentAttendancePredictionSuccess';
    constructor() {}
  }

  @logDispatcher
  export class SaveServiceAttendanceAdjustment {
    static readonly type = '[Monitor] SaveServiceAttendanceAdjustment';
    constructor(public user: string, public status: number) {}
  }

  @logDispatcher
  export class SaveServiceAttendanceAdjustmentSuccess {
    static readonly type = '[Monitor] SaveServiceAttendanceAdjustmentSuccess';
    constructor() {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Monitor] Error';
    constructor(public error: any, public details: string) {}
  }

  @logDispatcher
  export class SetIsContractForStudents {
    static readonly type = '[Monitor] SetIsContractForStudents';
    constructor(public isContractForStudents: boolean) {}
  }

  @logDispatcher
  export class SetIsListSmaller {
    static readonly type = '[Monitor] SetIsListSmaller';
    constructor(public isListSmaller: boolean) {}
  }

  @logDispatcher
  export class SetReloadData {
    static readonly type = '[Monitor] SetReloadData';
    constructor(public reloadData: boolean) {}
  }

  @logDispatcher
  export class SetStudentAttendanceMonitorDefaultState {
    static readonly type = '[Monitor] SetStudentAttendanceMonitorDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetSchoolAttendanceMonitorDefaultState {
    static readonly type = '[Monitor] SetSchoolAttendanceMonitorDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetStudentAttendancePredictionFormDefaultState {
    static readonly type =
      '[Monitor] SetStudentAttendancePredictionFormDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetServiceAttendanceAdjustmentDefaultState {
    static readonly type =
      '[Monitor] SetServiceAttendanceAdjustmentDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetDefaultState {
    static readonly type = '[Monitor] SetDefaultState';
    constructor() {}
  }
}
